import ProtectedRoute from 'auth/ProtectedRoute';
import ClinicalDataRecordRequiresAction from 'components/clinical-data/ClinicalDataRecordRequiresAction';
import ClinicalDataRecordView from 'components/clinical-data/ClinicalDataRecordView';
import React, { Fragment } from 'react';
import { Switch } from 'react-router';

const ClinicalDataRecordHome = () => (
    <Fragment>
      <Switch>
        <ProtectedRoute path="/clinical-data-record" exact component={ClinicalDataRecordView}/>
        <ProtectedRoute
            path="/clinical-data-record/procedure-created"
            exact
            component={(props: any) => <ClinicalDataRecordRequiresAction {...props} displayRequiresAction={false}/>}/>
        <ProtectedRoute
            path="/clinical-data-record/requires-action"
            exact
            component={(props: any) => <ClinicalDataRecordRequiresAction {...props} displayRequiresAction={true}/>}/>
      </Switch>
    </Fragment>
);

export default ClinicalDataRecordHome;
